(function () {
	'use strict';

	angular
		.module('wizard-future7.routes')
		.config(routes);

	/** @ngInject */
	function routes($stateProvider, $locationProvider, PATHS, $urlRouterProvider) {
		$locationProvider.html5Mode(true);
		$urlRouterProvider.otherwise('/nao-encontrado');

		$stateProvider
			.state('default', {
				abstract: true,
				title: 'Wizard Future7 - Preparando para o amanhã',
				templateUrl: `${PATHS.PHYSICAL}/components/default/layout/layout.html`,
				onEnter: ($rootScope, HelperService) => {
					$rootScope.hideLoading = true;
				}
			})


			// Ebook
			.state('default.ebook', {
				title: 'FUTURE7',
				url: '/ebook',
				templateUrl: `${PATHS.PHYSICAL}/components/default/ebook/ebook.html`,
				controller: 'DefaultEbookController',
				controllerAs: 'vm',
				params: {
					hideMenu: true
				}
			})

			//Home
			.state('default.countdown', {
				title: 'Wizard Future7 - Preparando para o amanhã',
				url: '/home?:solucao',
				templateUrl: `${PATHS.PHYSICAL}/components/default/homepage/homepage.html`,
				controller: 'DefaultHomeController',
				controllerAs: 'vm',
				params: {
					hideMenu: false
				}
			})

			.state('default.home', {
				title: 'Wizard Future7 - Preparando para o amanhã',
				url: '/?:solucao',
				templateUrl: `${PATHS.PHYSICAL}/components/default/homepage/homepage.html`,
				controller: 'DefaultHomeController',
				controllerAs: 'vm',
				params: {
					hideMenu: false
				}
			})

			// Home Quiz
			// .state('default.quiz-intro', {
			// 	title: 'Wizard Future7 - Teste de Competências',
			// 	url: '/quiz',
			// 	templateUrl: `${PATHS.PHYSICAL}/components/default/quiz/intro/intro.html`,
			// 	controller: 'DefaultQuizIntroController',
			// 	controllerAs: 'vm',
			// 	params: {
			// 		hideMenu: false
			// 	}
			// })

			// // Astronaut Quiz
			.state('default.quiz-astronaut', {
				title: 'Wizard Future7 - Teste de Competências',
				url: '/quiz/astronauta',
				templateUrl: `${PATHS.PHYSICAL}/components/default/quiz/astronaut/astronaut.html`,
				controller: 'DefaultQuizAstronautController',
				controllerAs: 'vm',
				params: {
					hideMenu: false
				}
			})

			// // Questions Quiz
			.state('default.quiz-questions', {
				title: 'Wizard Future7 - Teste de Competências',
				url: '/quiz/questionario',
				templateUrl: `${PATHS.PHYSICAL}/components/default/quiz/questions/questions.html`,
				controller: 'DefaultQuizQuestionsController',
				controllerAs: 'vm',
				params: {
					hideMenu: false
				}
			})

			// // Register Quiz
			.state('default.quiz-register', {
				title: 'Wizard Future7 - Teste de Competências',
				url: '/quiz/cadastro',
				templateUrl: `${PATHS.PHYSICAL}/components/default/quiz/register/register.html`,
				controller: 'DefaultQuizRegisterController',
				controllerAs: 'vm',
				params: {
					hideMenu: false
				}
			})

			// Result Quiz
			.state('default.quiz-result', {
				title: 'Wizard Future7 - Teste de Competências',
				url: '/quiz/resultado/{resultHash}',
				templateUrl: `${PATHS.PHYSICAL}/components/default/quiz/result/result.html`,
				controller: 'DefaultQuizResultController',
				controllerAs: 'vm',
				params: {
					resultHash: {
						value: ''
					},
					hideMenu: false
				}
			})

			// Videos
			.state('default.videos', {
				title: 'Wizard Future7 - Vídeos dos Cursos Future7',
				url: '/videos/{video}',
				templateUrl: `${PATHS.PHYSICAL}/components/default/video/video.html`,
				controller: 'DefaultVideoController',
				controllerAs: 'vm',
				params: {
					video: {
						value: ''
					},
					hideMenu: false
				}
			})

			.state('default.not-found', {
				title: 'Não encontrado',
				url: '/nao-encontrado',
				templateUrl: `${PATHS.PHYSICAL}/components/default/common/not-found.html`,
				controller: 'DefaultCommonController',
				controllerAs: 'vm',
				params: {
					hideMenu: false
				}
			})

	}
}());